var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapper"}},[_c('Nav',{attrs:{"message":_vm.message}}),_c('Invoice')],1)}
var staticRenderFns = []

export { render, staticRenderFns }